export default function ngBackground(){
    return {
        scope: {background: '@ngBackground'},
        link: function ($scope, $item, $params) {
            $scope.$watch('background', function (value) {
                $item.css('background-image', 'url(\'' + value.replace('\'', '%27') + '\')');
            }, true);
        }
    }
};

